import store from "../../store/configure-store";
import { setBalanceValue, /* updateOnlyBalance, */ addToBalance } from "../../store/entities/balance-slice";
// Stari bet-slice više nije potreban; ukloni sve reference ako ih ima:
// import { setActiveBet } from "../../store/entities/bet-slice";
import { setCashout } from "../../store/entities/cashout-slice";
import { toggleFreeBetsState } from "../../store/entities/free-bets-state-slice";
import { setFreeTicketInfo } from "../../store/entities/freetickets/free-ticket-info-slice";
import { setInitialHitOdds } from "../../store/entities/hit-odds-slice";
import { setJackpotValue } from "../../store/entities/jackpot-slice";
import { setLoginData } from "../../store/entities/login-slice";
import { setAlreadyShownBonusModal, setBounsRoundsModal } from "../../store/entities/modals/bonus-rounds-modal-slice";
import { setPopupMessage } from "../../store/entities/popup-message-slice";
import { setServerMessage } from "../../store/entities/server-messages-slice";
import { shouldShowBonusModal } from "../bonuses/bounus-modal";
import { setsProperBonusLabel } from "../free-tickets/show-bonus-label";
import { setActiveBet } from "../../store/entities/bet-slice";
import gameDifficultyConverter from "../helpers/game-difficulty-helper";
import {
  upsertFromAck,
  markBallDone,
  remove as removePending,
} from "../../store/entities/pending-bets-slice";
import { tlog } from "../log";
import { setTurboMode } from "../../store/entities/turbo-mode-slice";
import { setTurboModeModal } from "../../store/entities/modals/turbo-mode-modal-slice";
import translate from "../translation/lang";
import { setBetHistoryList } from "../../store/entities/bet-history-slice";
import soundFxPlayer from "../audio/soundfx-player";
import { ballsInSecParam } from "../helpers/login-params";
import { getCurrencyNumberOfDigits } from "../helpers/customization-helper";

// na vrhu fajla:
let MINOR_FACTOR = 100; // default 2 dec
function setMinorFactorFromLogin(loginData) {
  // Novi snake_case field ima prioritet (player_data ili top-level), zatim stari PascalCase
  const fromPlayerData = loginData?.player_data?.currency_number_of_digits;
  const fromTopLevel   = loginData?.currency_number_of_digits;
  const fromLegacy     = loginData?.CompanyCurrencyData?.NumberOfDigits;

  const raw = fromPlayerData ?? fromTopLevel ?? fromLegacy;
  const digits = Number(raw);

  if (Number.isInteger(digits) && digits >= 0 && digits <= 4) {
    MINOR_FACTOR = Math.pow(10, digits);
  } else {
    MINOR_FACTOR = 100; // fallback
  }
}

function toMinor(x) {
  const n = Number(x) || 0;
  return Math.round(n * MINOR_FACTOR);
}

function fromMinor(m) {
  const n = Number(m) || 0;
  return n / MINOR_FACTOR;
}

// Formatira win iznos za notifikaciju:
// - ako backend vrati ≤2 decimale → prikaži tačno kako je stiglo
// - ako vrati >2 decimale → truncate na max(currency_number_of_digits, 2)
function formatWinForDisplay(rawWin) {
  const val = Number(rawWin || 0);
  const str = String(val);
  const dotIdx = str.indexOf(".");
  const actualDecimals = dotIdx === -1 ? 0 : str.length - dotIdx - 1;

  if (actualDecimals <= 2) return val;

  const targetDigits = Math.max(getCurrencyNumberOfDigits() ?? 2, 2);
  const factor = Math.pow(10, targetDigits);
  return Math.floor(val * factor) / factor;
}

/**
 * PlinkoTransport
 * - Koordinator za bet_ack + ball_done (Model A: delta win primenjujemo tek kad lopta padne)
 */
class PlinkoTransport {
  constructor() {
    if (!PlinkoTransport.instance) {
      this.turboHold = false;     // da li je korisnik “drži” turbo
      this.turboPending = false;  // čekamo server potvrdu za poslednji item
      this.turboWatchdog = null;
      // TURBO: odloženi win-ovi po jedinstvenom UID-u "ticketId:seq"
      this.pendingTurboWins = new Map();   // key: "127258:1" -> Number(win_money)
      this.turboCounters   = new Map();    // key: ticket_id (Number) -> last seq (Number)
      this._turboDebug     = false;         // uključi/isključi debug logove
      this.turboRestart = null;        // { betAmount, rows, level }
      this.turboRestartForTicket = null; // da znamo za koji ticket smo tražili restart
      this.nextTurboStartValue = null;
      this.allowedTurboDrops = new Set(); // uid-evi za koje FE sme da animira drop
      this.turboAutoCashoutPending = false; // da ne šaljemo turbo_cashout više puta

      // rate limit iz login-a (ms) za turbo_bet_item
      this.turboBetSpeedLimitMs = 0;     // integer ms, 0 = no limit
      this.lastTurboItemSentAt = 0;      // Date.now() timestamp (poslednji SEND)
      this.turboRateTimer = null;        // timeout id za odloženi next

      // skup ticket-a koji su cashout-ovani na BE
      this.cashedOutTickets = new Set();

      // === NEW: live balls tracking (da ne cashout-ujemo dok lopte nisu u džepovima) ===
      this.liveTurboUids = new Set();            // Set<"ticketId:seq">
      this.liveTurboCountByTicket = new Map();   // Map<Number, Number>
      this.pendingEndTicketId = null;            // Number|null

      // 900s inactivity: ako igrač ne odigra ni jedan bet nakon otvaranja turbo moda
      this.turboAtLeastOneBetPlaced = false;   // true čim prvi turboBetItem prođe
      this.turboInactivityTimer = null;        // setTimeout handle (900s)
      this.turboWarningTimer = null;           // setTimeout handle (870s — upozorenje 30s prije)
      this.turboCashoutFromInactivity = false; // preskoči success popup kad ga pokrene inactivity

      // sessionStorage helpers — čuvamo inactivity stanje per ticketId između reloada
      this._turboSessionKey = (id) => `turbo_inactivity_${id}`;

      this._saveTurboSession = (ticketId, atLeastOneBetPlaced, startedAt) => {
        try {
          sessionStorage.setItem(
            this._turboSessionKey(ticketId),
            JSON.stringify({ atLeastOneBetPlaced, startedAt: startedAt ?? Date.now() })
          );
        } catch (_) { /* sessionStorage nedostupan */ }
      };

      this._loadTurboSession = (ticketId) => {
        try {
          const raw = sessionStorage.getItem(this._turboSessionKey(ticketId));
          return raw ? JSON.parse(raw) : null;
        } catch (_) { return null; }
      };

      this._clearTurboSession = (ticketId) => {
        try {
          if (ticketId != null) sessionStorage.removeItem(this._turboSessionKey(ticketId));
        } catch (_) { /* ignore */ }
      };

      // lagani wrapper za logovanje
      this.dlog = (...args) => {
        if (this._turboDebug) {
          console.log("[TURBO/DBG]", ...args);
        }
      };

      // pomoćni ispis sadržaja mape (ključna stvar za dijagnostiku)
      this.debugListTurboWins = () => {
        const entries = Array.from(this.pendingTurboWins.entries())
          .map(([k, v]) => ({ uid: k, win: v }));
        this.dlog("pendingTurboWins size=", this.pendingTurboWins.size, entries);
        return entries;
      };

      PlinkoTransport.instance = this;
    }
    return PlinkoTransport.instance;
  }

  _requestTurboCashout(ticketId, { silent = true } = {}) {
    const st = store.getState();
    const sid = st.login?.sid;
    if (!sid || !ticketId) return;

    if (this.turboAutoCashoutPending) return;
    this.turboAutoCashoutPending = true;

    // prekini loop odmah
    this.turboHold = false;
    this.turboPending = false;
    this._clearTurboWatchdog();
    this._clearTurboRateTimer();
    this.clearTurboDropsForTicket(ticketId);

    if (!silent) {
      store.dispatch(setPopupMessage({
        message: translate("ending_turbo_mode") || "Ending Turbo mode...",
        delay: 2000,
      }));
    }

    store.dispatch({
      type: "WEBSOCKET_SEND",
      payload: ["turbo_cashout", { sid, ticketId }],
    });
  }

  allowTurboDrop(uid) {
    if (!uid) return;
    this.allowedTurboDrops.add(String(uid));

    // safety: da ne curi memorija ako se nešto “zaglibi”
    if (this.allowedTurboDrops.size > 5000) {
      // obriši najstarije na grubo (Set nema “pop first” direktno)
      const it = this.allowedTurboDrops.values();
      for (let i = 0; i < 1000; i++) {
        const n = it.next();
        if (n.done) break;
        this.allowedTurboDrops.delete(n.value);
      }
    }
  }

  consumeTurboDrop(uid) {
    const key = String(uid || "");
    if (!this.allowedTurboDrops.has(key)) return false;
    this.allowedTurboDrops.delete(key);
    return true;
  }

  clearTurboDropsForTicket(ticketId) {
    const prefix = `${Number(ticketId)}:`;
    for (const uid of Array.from(this.allowedTurboDrops)) {
      if (uid.startsWith(prefix)) this.allowedTurboDrops.delete(uid);
    }
  }

  setNextTurboStartValue(value) {
    const n = Number(value);
    this.nextTurboStartValue = Number.isFinite(n) ? n : null;
  }

  queueTurboRestart(data) {
    // data: { betAmount, rows, level }
    this.turboRestart = data || null;

    // zapamti trenutni ticketId (da restartujemo baš posle njegovog cashout-a)
    const st = store.getState();
    this.turboRestartForTicket = Number(st.turboMode?.ticketId) || null;
  }

  _clearTurboWatchdog() {
    if (this.turboWatchdog) {
      clearTimeout(this.turboWatchdog);
      this.turboWatchdog = null;
    }
  }

  _clearTurboRateTimer() {
    if (this.turboRateTimer) {
      clearTimeout(this.turboRateTimer);
      this.turboRateTimer = null;
    }
  }

  // === 900s inactivity timer ===
  _clearTurboInactivityTimer() {
    if (this.turboWarningTimer) {
      clearTimeout(this.turboWarningTimer);
      this.turboWarningTimer = null;
    }
    if (this.turboInactivityTimer) {
      clearTimeout(this.turboInactivityTimer);
      this.turboInactivityTimer = null;
    }
  }

  // remainingMs: preostalo vreme u ms; ako nije prosleđeno koristi ticket_timeout_s iz logina (fallback 900s)
  _startTurboInactivityTimer(ticketId, remainingMs) {
    this._clearTurboInactivityTimer();
    const loginData = store.getState().login;
    const timeoutS = Number(
      loginData?.ticket_timeout_s ??
      loginData?.player_data?.ticket_timeout_s ??
      900
    );
    const TOTAL_MS = (Number.isFinite(timeoutS) && timeoutS > 0 ? timeoutS : 900) * 1000;
    const totalMs    = (Number.isFinite(remainingMs) && remainingMs > 0) ? remainingMs : TOTAL_MS;
    const WARNING_OFFSET_MS = 30 * 1000; // upozorenje 30s prije isteka
    const warningMs  = Math.max(0, totalMs - WARNING_OFFSET_MS);

    // Upozorenje (samo ako ima dovoljno vremena da se prikaže)
    if (warningMs > 0) {
      this.turboWarningTimer = setTimeout(() => {
        this.turboWarningTimer = null;
        if (!store.getState().turboMode?.state) return;
        store.dispatch(setPopupMessage({
          message:
            translate("time_running_out") ||
            "Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec",
          delay: 5000,
        }));
      }, warningMs);
    } else {
      // Manje od 30s preostalo — odmah prikaži upozorenje
      if (store.getState().turboMode?.state) {
        store.dispatch(setPopupMessage({
          message:
            translate("time_running_out") ||
            "Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec",
          delay: Math.max(1000, totalMs - 500),
        }));
      }
    }

    // Akcija na totalMs (900s za novu sesiju, ili preostalo vreme za resume)
    this.turboInactivityTimer = setTimeout(() => {
      this.turboInactivityTimer = null;
      const st = store.getState();
      if (!st.turboMode?.state) return;

      store.dispatch(setPopupMessage({
        message: translate("cashout_inactivity") || "Party cashout on inactivity",
        delay: 5000,
      }));

      // Označi da cashout dolazi od inactivity → turboCashout handler neće prikazati success popup
      this.turboCashoutFromInactivity = true;

      if (this.turboAtLeastOneBetPlaced) {
        // Bar jedan bet odigran → cashout
        this._requestTurboCashout(ticketId, { silent: true });
      } else {
        // Ni jedan bet → cancel
        const sid = st.login?.sid;
        store.dispatch({
          type: "WEBSOCKET_SEND",
          payload: ["turbo_cashout", { sid, ticketId }],
        });
      }
    }, totalMs);
  }

  // Za UI: da li je bar jedan bet odigran u ovoj turbo sesiji?
  hasTurboAtLeastOneBet() {
    return this.turboAtLeastOneBetPlaced;
  }

  _armTurboWatchdog(ms = 5000) {
    this._clearTurboWatchdog();
    this.turboWatchdog = setTimeout(() => {
      // Nema odgovora dovoljno dugo → prekinuti burst, odlediti pending
      this.turboPending = false;
      this.turboHold = false;
      this.turboAutoCashoutPending = false;
      this._clearTurboRateTimer();
      store.dispatch(setPopupMessage({
        message: translate("server_timeout_please_try_again") || "Server timeout, please try again.",
        delay: 4000,
      }));
    }, ms);
  }

  // === HELPERI za cashout guard ===
  _uidToTicketId(uid) {
    if (typeof uid !== "string") return null;
    const t = Number(uid.split(":")[0]);
    return Number.isFinite(t) ? t : null;
  }

  // === NEW: live balls helpers (da end/cashout sačeka da lopte upadnu) ===
  // Brojimo direktno iz liveTurboUids (jedini izvor istine) da ne bude desinhronizacije sa Map-om.
  _getLiveCountForTicket(ticketId) {
    const tId = Number(ticketId);
    if (!Number.isFinite(tId)) return 0;
    let count = 0;
    for (const uid of this.liveTurboUids) {
      if (this._uidToTicketId(uid) === tId) count++;
    }
    return count;
  }

  _markTurboBallLive(uid) {
    const u = String(uid || "");
    if (!u.includes(":")) return;

    if (this.liveTurboUids.has(u)) return; // safety
    this.liveTurboUids.add(u);

    const tId = this._uidToTicketId(u);
    if (!Number.isFinite(tId)) return;

    const prev = this.liveTurboCountByTicket.get(tId) || 0;
    this.liveTurboCountByTicket.set(tId, prev + 1);
  }

  _markTurboBallDone(uid) {
    const u = String(uid || "");
    if (!this.liveTurboUids.has(u)) return; // nije označena kao live
    this.liveTurboUids.delete(u);

    const tId = this._uidToTicketId(u);
    if (!Number.isFinite(tId)) return;

    const prev = this.liveTurboCountByTicket.get(tId) || 0;
    const next = Math.max(0, prev - 1);
    if (next === 0) this.liveTurboCountByTicket.delete(tId);
    else this.liveTurboCountByTicket.set(tId, next);

    // ako čekamo end baš za ovaj ticket, probaj da završiš
    if (this.pendingEndTicketId != null && Number(this.pendingEndTicketId) === Number(tId)) {
      this._finalizePendingTurboEndIfReady(tId);
    }
  }

  _schedulePendingTurboEnd(ticketId) {
    const tId = Number(ticketId);
    if (!Number.isFinite(tId)) return;

    this.pendingEndTicketId = tId;

    // stopuj dalje slanje item-a
    this.turboHold = false;
    this.turboPending = false;
    this._clearTurboWatchdog();
    this._clearTurboRateTimer();

    // ako nema live lopti, završi odmah
    this._finalizePendingTurboEndIfReady(tId);
  }

  _finalizePendingTurboEndIfReady(ticketId) {
    const tId = Number(ticketId);
    if (!Number.isFinite(tId)) return;

    const live = this._getLiveCountForTicket(tId);
    if (live > 0) return; // još čekamo lopte

    // Sve lopte su pale — proveri da li su dobici u međuvremenu napunili turbo balance.
    // Ako je balance >= minBet, otkaži pending end i nastavi sa igrom.
    const st = store.getState();
    const currentValue = Number(st.turboMode?.value) || 0;
    const minBet = Number(
      st.login?.player_data?.company_currency_data?.min_bet ??
        st.login?.CompanyCurrencyData?.MinBet ??
        0
    ) || 0;

    if (minBet > 0 && currentValue >= minBet) {
      // Dobici su napunili turbo balance iznad minBet — otkaži cashout i nastavi
      this.pendingEndTicketId = null;
      this.dlog("PENDING END cancelled — balance replenished by wins", { currentValue, minBet });
      return;
    }

    // sada je bezbedno cashout
    this.pendingEndTicketId = null;
    this._requestTurboCashout(tId, { silent: true });
  }

  _clearPendingWinsForTicket(ticketId) {
    if (!Number.isFinite(ticketId)) return;
    for (const key of Array.from(this.pendingTurboWins.keys())) {
      if (this._uidToTicketId(key) === ticketId) {
        this.pendingTurboWins.delete(key);
      }
    }
  }

  turboStartHold() {
    this.turboHold = true;
    this._clearTurboRateTimer(); // u slučaju da je ostao neki zakazan next
    this._tryTurboNext();
  }

  turboStopHold() {
    this.turboHold = false;
    this._clearTurboRateTimer();
  }

  _tryTurboNext() {
    if (!this.turboHold) {
      console.log("[TURBO] skip: hold=false");
      return;
    }
    if (this.turboPending) {
      console.log("[TURBO] skip: pending=true");
      return;
    }

    const st = store.getState();

    const sid = st.login?.sid;
    const { ticketId, value } = st.turboMode || {};
    const betAmountRaw = st.betAmount;

    const rows = st.numberOfRows;
    const level = gameDifficultyConverter(st.gameDifficulty);

    // --- min/max čitanje (pokrivamo obe strukture koje se pojavljuju u kodu) ---
    const minBet =
      Number(
        st.login?.player_data?.company_currency_data?.min_bet ??
          st.login?.CompanyCurrencyData?.MinBet ??
          0
      ) || 0;

    const maxBet =
      Number(
        st.login?.player_data?.company_currency_data?.max_bet ??
          st.login?.CompanyCurrencyData?.MaxBet ??
          0
      ) || 0;

    const currency =
      st.login?.CurrencyID ||
      st.login?.player_data?.currency_code?.CurrencyID ||
      "";

    // --- stop uslovi koji nemaju veze sa validacijom ---
    if (!sid || !ticketId) return;

    // --- VALIDACIJA betAmount (prazno / 0 / NaN) ---
    const betAmount = Number(betAmountRaw);
    if (!Number.isFinite(betAmount) || betAmount <= 0) {
      this.turboHold = false;
      store.dispatch(
        setPopupMessage({
          message:
            (translate("invalid_bet_amount") || "Invalid bet amount.") +
            (minBet > 0 ? ` ${translate("min_bet_amount_is") || "Min bet amount is"} ${minBet} ${currency}` : ""),
          delay: 4000,
        })
      );
      return;
    }

    // --- turbo budget guard (remaining turbo value) ---
    // MORA biti PRE min/max betAmount provjere — ako je turbo balance < minBet,
    // auto cashout ima prioritet nad "min bet" validacijom betAmount-a.
    // Koristimo direktne float vrednosti bez toMinor/Math.round —
    // zaokruživanje u toMinor može da maskira preciznost (npr. 0.099 → 10 minor = 0.10)
    const effectiveValue = Number(value) || 0;

    // 1) Turbo balance = 0 ili < min bet → auto cashout sekvenca
    if (effectiveValue <= 0 || (minBet > 0 && effectiveValue < minBet)) {
      // turboHold = false MORA biti ovde — sprečava da ballDone/turboBetItem
      // ponovo pozovu _tryTurboNext koji bi s refreshovanim balanceom (po win-u)
      // prošao BLOK 1 i pao u BLOK 2 s porukom "bet too large" iako igrač nije ništa pogrešio
      this.turboHold = false;
      this._clearTurboRateTimer();
      this._clearTurboWatchdog();

      const live = this._getLiveCountForTicket(ticketId);

      if (live <= 0) {
        // Nema živih loptica → odmah cashout
        this._requestTurboCashout(ticketId, { silent: true });
      } else {
        // Ima živih loptica → čekaj da sve padnu pa cashout
        this._schedulePendingTurboEnd(ticketId);
        // Poruku prikazujemo samo ako je ostalo nešto u balansu ali ispod minBet
        // (igrač nije sve potrošio — npr. 0.05 ostatak uz minBet 0.10)
        // Kada je balance tačno 0, igrač je validno odigrao sve — cashout je tih
        if (effectiveValue > 0) {
          store.dispatch(
            setPopupMessage({
              message: translate("insufficiend_funds") || "Insufficient funds",
              delay: 3500,
            })
          );
        }
      }
      return;
    }

    // 2) Turbo balance >= minBet ali betAmount > turboBalance → poruka, bez cashout-a, bez dropa
    // turboHold = false sprečava automatski sledeći drop (igrač mora smanjiti bet)
    if (betAmount > effectiveValue) {
      this.turboHold = false;
      this._clearTurboWatchdog();
      this._clearTurboRateTimer();
      store.dispatch(
        setPopupMessage({
          message:
            translate("bet_too_large_top_up_turbo_balance") ||
            "Bet too large — top up your Turbo balance!",
          delay: 3500,
        })
      );
      return;
    }

    // --- min/max betAmount validacija (dolazi POSLE turbo budget guarda) ---
    if (minBet > 0 && betAmount < minBet) {
      this.turboHold = false;
      store.dispatch(
        setPopupMessage({
          message: `${translate("min_bet_amount_is")} ${minBet} ${currency}`,
          delay: 4000,
        })
      );
      return;
    }

    if (maxBet > 0 && betAmount > maxBet) {
      this.turboHold = false;
      store.dispatch(
        setPopupMessage({
          message: `${translate("max_bet_is")} ${maxBet} ${currency}`,
          delay: 4000,
        })
      );
      return;
    }

    // --- rate limiting za turbo_bet_item (min interval između SEND-ova) ---
    // Napomena: turboPending već garantuje da se čeka odgovor/ACK za prethodni item.
    // Ovde eksplicitno koristimo ballsInSec parametar za TURBO brzinu,
    // tako da npr. 10 => 10 lopti u sekundi (interval ~= 100ms).
    const raw = Number(ballsInSecParam);
    const ballsInSec =
      Number.isFinite(raw) && raw >= 1 && raw <= 10 ? raw : 5;
    
    const clientLimitMs = 1000 / ballsInSec;
    const limitMs = clientLimitMs > 0
      ? clientLimitMs
      : (Number(this.turboBetSpeedLimitMs) || 0);
    
    if (limitMs > 0) {
      const now = Date.now();
      const elapsed = now - (this.lastTurboItemSentAt || 0);
    
      // ako je poslednji send bio skoro, odloži sledeći pokušaj
      if (this.lastTurboItemSentAt && elapsed < limitMs) {
        const wait = limitMs - elapsed;
    
        // ne zakazuj više puta
        if (!this.turboRateTimer) {
          this.turboRateTimer = setTimeout(() => {
            this.turboRateTimer = null;
            this._tryTurboNext();
          }, wait);
        }
        return;
      }
    }

    // --- pošalji turbo_bet_item ---
    // IMPORTANT: označi pending PRE slanja, da ne može dupli send pre ack-a
    this.turboPending = true;

    // zapamti vreme slanja (rate limit se odnosi na SEND-ove; ACK se čeka preko turboPending)
    this.lastTurboItemSentAt = Date.now();

    store.dispatch({
      type: "WEBSOCKET_SEND",
      payload: [
        "turbo_bet_item",
        {
          sid,
          isAutobet: 0,
          betAmount: String(betAmount), // sigurnije: šaljemo normalizovan broj
          ticketId,
          rows,
          level,
        },
      ],
    });

    this._armTurboWatchdog(5000);
  }

  // sabiranje u centima (minor) radi izbegavanja floating repova
  _addMinor(deltaMinor) {
    const val = fromMinor(deltaMinor); // vrati decimalu bez repova
    store.dispatch(addToBalance(val));
  }

  // === PRIVATE: ako su ACK i BALL_DONE prisutni, primeni win i skloni pending ===
  _settleIfReady(ticketId) {
    const st = store.getState();
    const item = st.pendingBets.byId[ticketId];
    if (!item) return;

    const ready = item.hasAck && item.hasBallDone && item.winAmount != null;
    if (ready) {
      const winMinor = toMinor(Number(item.winAmount) || 0);
      const before = st.balance.balance;
      tlog("SETTLE start (+win)", { ticketId, win: fromMinor(winMinor), beforeClientBalance: before });
      this._addMinor(winMinor);
      store.dispatch(removePending({ ticketId }));
      const after = store.getState().balance.balance;
      tlog("SETTLE done (+win)", { ticketId, afterClientBalance: after });
    }
  }

  // === Canvas: pozovi kad lopta padne ===
  ballDone(ticketId) {
    // ticketId iz UI:
    //  - turbo: "127258:3"
    //  - klasičan: broj (npr. 127258)

    const tidStr = String(ticketId);
    this.dlog("BALL_DONE recv", { ticketId: tidStr });

    // TURBO grana (UID sa ':')
    if (tidStr.includes(":")) {
      const tId = this._uidToTicketId(tidStr);
      // ako je ticket cashout-ovan na BE → ignoriši win i očisti eventualni pending
      if (Number.isFinite(tId) && this.cashedOutTickets.has(tId)) {
        this.pendingTurboWins.delete(tidStr);
        this.dlog("BALL_DONE ignored (cashed out)", { uid: tidStr, ticketId: tId });

        // i dalje obeleži da je lopta završila (da pending end može da se odradi)
        this._markTurboBallDone(tidStr);
        return;
      }

      // Dodaj win u turbo balance kada lopta fizički padne u slot
      if (this.pendingTurboWins.has(tidStr)) {
        const win = Number(this.pendingTurboWins.get(tidStr)) || 0;
        this.pendingTurboWins.delete(tidStr);
        if (win > 0) {
          this.dlog("APPLY WIN (turbo balance)", { uid: tidStr, win });
          const tm = store.getState().turboMode || {};
          store.dispatch(setTurboMode({
            state: tm.state,
            value: (Number(tm.value) || 0) + win,
            ticketId: tm.ticketId,
          }));
        } else {
          this.dlog("APPLY WIN skipped (win=0)", { uid: tidStr, win });
        }
      } else {
        this.dlog("NO WIN for UID", { uid: tidStr });
      }
      this.debugListTurboWins();

      // Lopta je završila (upala u džep)
      this._markTurboBallDone(tidStr);

      // Provjeri balance nakon svakog pada loptice, čak i kad _tryTurboNext nije pokrenuo provjeru
      // (npr. manual mode — korisnik je pustio dugme, turboHold=false, setTimeout bio skip-ovan).
      // Ako je balance < minBet i nema više živih loptica → odmah cashout.
      if (this.pendingEndTicketId == null && !this.cashedOutTickets.has(tId)) {
        const stAfter = store.getState();
        if (stAfter.turboMode?.state) {
          const currentValue = Number(stAfter.turboMode?.value) || 0;
          const minBetAfter = Number(
            stAfter.login?.player_data?.company_currency_data?.min_bet ??
            stAfter.login?.CompanyCurrencyData?.MinBet ??
            0
          ) || 0;
          const liveAfter = this._getLiveCountForTicket(tId);
          if (minBetAfter > 0 && currentValue < minBetAfter) {
            if (liveAfter <= 0) {
              this._requestTurboCashout(tId, { silent: true });
            } else {
              this._schedulePendingTurboEnd(tId);
            }
          }
        }
      }

      return;
    }

    // Klasična grana (bez UID-a): pendingBets flow
    store.dispatch(markBallDone({ ticketId: Number(tidStr) }));
    this._settleIfReady(Number(tidStr));
  }

  // === Login ===
  login(data) {
    console.log("Login data:", data);
    this.allowedTurboDrops.clear();
    this.cashedOutTickets.clear();
    this.pendingTurboWins.clear();
    this.turboCounters.clear();
    this.turboRestart = null;
    this.turboRestartForTicket = null;

    // NEW: reset end/live tracking
    this.pendingEndTicketId = null;
    this.liveTurboUids.clear();
    this.liveTurboCountByTicket.clear();

    // turbo rate limit (ms)
    const lim = Number(data?.turbo_bet_speed_limit);
    this.turboBetSpeedLimitMs = Number.isFinite(lim) && lim > 0 ? Math.floor(lim) : 0;

    // reset rate limiter state
    this.lastTurboItemSentAt = 0;
    this._clearTurboRateTimer();
    this._clearTurboInactivityTimer();
    this.turboAtLeastOneBetPlaced = false;

    // 1) currency precision → minor factor
    setMinorFactorFromLogin(data);
    this.turboAutoCashoutPending = false;
    // 2) standard login state
    store.dispatch(setLoginData(data));
    store.dispatch(setInitialHitOdds(data?.player_ticket_history || []));

    // 3) RESUME turbo mode ako BE vrati otvorene tikete
    const open = Array.isArray(data?.open_tickets) ? data.open_tickets : [];

    if (open.length > 0) {
      // Turbo ticket prepoznajemo po turbo_bet (a ne po remaining_money)
      const t =
        open.find(o => o?.ticket_id != null && Number(o?.turbo_bet) > 0) ||
        open.find(o => o?.ticket_id != null) ||
        open[0];

      const ticketId = t?.ticket_id != null ? Number(t.ticket_id) : null;

      // remaining može biti 0 (npr. potrošeno, čeka da lopte upadnu)
      const remaining = Number(t?.remaining_money ?? 0);

      if (Number.isFinite(ticketId) && ticketId) {
        store.dispatch(
          setTurboMode({
            state: true,
            value: Number.isFinite(remaining) ? remaining : 0,
            ticketId,
          })
        );

        // Nastavi inactivity timer — prioritet: BE expires_in_s → sessionStorage startedAt → ticket_timeout_s
        const expiresInS = Number(t?.expires_in_s);
        const timeoutS = Number(
          data?.ticket_timeout_s ??
          data?.player_data?.ticket_timeout_s ??
          900
        );
        const totalTimeoutMs = (Number.isFinite(timeoutS) && timeoutS > 0 ? timeoutS : 900) * 1000;
        let remainingMs;

        if (Number.isFinite(expiresInS) && expiresInS > 0) {
          remainingMs = expiresInS * 1000;
        } else {
          // BE nije poslao expires_in_s — koristimo sačuvani startedAt iz sessionStorage
          const saved = this._loadTurboSession(ticketId);
          if (saved?.startedAt) {
            const elapsed = Date.now() - saved.startedAt;
            const left = totalTimeoutMs - elapsed;
            remainingMs = left > 0 ? left : 1000; // min 1s da odmah okine
          }
          // undefined → _startTurboInactivityTimer će koristiti ticket_timeout_s iz logina
        }

        // Učitaj bet flag iz sessionStorage; fallback false (konzervativno — traži bet)
        const savedSession = this._loadTurboSession(ticketId);
        this.turboAtLeastOneBetPlaced = savedSession?.atLeastOneBetPlaced === true;

        this._startTurboInactivityTimer(ticketId, remainingMs);
      }
    }
    const tm = store.getState().turboMode;
    if (tm?.state) {
      setTimeout(() => this.getUserBalance(), 200);
    }
  }

  // === Balance push iz BE-a (ako ga koristiš u drugim porukama) ===
  balance(balance) {
    store.dispatch(setBalanceValue(balance));
  }

  getUserBalance() {
    const state = store.getState();
    const sid = state.login?.sid;
    store.dispatch({
      type: "WEBSOCKET_SEND",
      payload: ["get_user_balance", { sid }],
    });
  }

  // === Jackpot ===
  jackpot(jackpot) {
    store.dispatch(setJackpotValue(jackpot));
  }

  turboBetAck(payload) {
    if (payload?.bet_passed === true) {
      store.dispatch(setBalanceValue(payload.balance));

      // 1) uzmi vrednost koju smo planirali da kupimo
      const planned = this.nextTurboStartValue;
      this.nextTurboStartValue = null;

      // 2) fallback ako planned nije setovan (za svaki slučaj)
      const fallback =
        Number(payload?.remaining_money ?? payload?.value ?? payload?.bet ?? 0) || 0;

      store.dispatch(setTurboMode({
        value: planned != null ? planned : fallback,
        ticketId: payload.ticket_id,
        state: true,
      }));

      // Nova sesija: reset bet-flag, sačuvaj u sessionStorage i pokreni 900s inactivity timer
      this.turboAtLeastOneBetPlaced = false;
      this._saveTurboSession(payload.ticket_id, false);
      this._startTurboInactivityTimer(payload.ticket_id);
    }
  }

  turboBetItem(payload) {
    // { bet_passed: true/false, id, itemId, ticket_id, total_win_money, win_money }

    // stigao odgovor → očisti watchdog/pending
    this._clearTurboWatchdog();
    this.turboPending = false;

    // ako BET NIJE PROŠAO — samo poruka (ne diramo value, ne triggujemo drop)
    if (payload?.bet_passed !== true) {
      const reason =
        payload?.reason ||
        payload?.message ||
        translate("bet_rejected") ||
        "Bet rejected.";
      store.dispatch(setPopupMessage({ message: reason, delay: 4000 }));
      this.dlog("ITEM REJECTED", { payload });
      return;
    }

    const st = store.getState();
    const betAmount = st.betAmount;
    const { ticketId, value } = st.turboMode || {};

    // zaštita: ako payload nije za aktivni ticket
    if (ticketId && payload?.ticket_id && Number(payload.ticket_id) !== Number(ticketId)) {
      this.dlog("IGNORED ITEM (different ticket)", { activeTicket: ticketId, payloadTicket: payload?.ticket_id });
      return;
    }

    // Prvo izračunaj UID i označi loptu kao "live" PRE nego što smanjimo value.
    // Tako _tryTurboNext (koji se pozove na kraju) uvek vidi tačan live count i ne radi cashout dok lopte padnu.
    let ticketUid = null;
    if (payload?.ticket_id != null && payload?.id != null) {
      const tIdNum = Number(payload.ticket_id);

      if (Number.isFinite(tIdNum) && this.cashedOutTickets.has(tIdNum)) {
        this.dlog("ITEM IGNORED (ticket cashed out)", { ticketId: tIdNum });
        return;
      }

      const last = this.turboCounters.get(tIdNum) || 0;
      const seq  = last + 1;
      this.turboCounters.set(tIdNum, seq);
      ticketUid = `${tIdNum}:${seq}`;
      this._markTurboBallLive(ticketUid);
    }

    // umanji turbo value za betAmount (vizualni feedback odmah)
    // Koristimo direktnu float aritmetiku (bez toMinor/fromMinor) da se izbegne
    // akumulirana greška zaokruživanja — vrednost se čuva sirova, odseca se samo za prikaz.
    // Klampujemo na 0 u dva slučaja:
    //   a) IEEE 754 šum (npr. 1.26 - 1.26 = 2.22e-16) — prag: 0.5 / MINOR_FACTOR
    //   b) Sub-displayable ostatak (npr. raw=0.028, bet=0.02 → ostatak=0.008 < 0.01)
    //      Igrač "vidi" 0.00 u UI-u pa je logično tretirati ga kao 0
    const _rawNext = value - betAmount;
    const _noiseThreshold = 0.5 / MINOR_FACTOR;
    const _displayUnit = 1 / MINOR_FACTOR;
    const nextValue = (_rawNext <= _noiseThreshold || _rawNext < _displayUnit) ? 0 : _rawNext;

    store.dispatch(setTurboMode({
      value: nextValue,
      ticketId: ticketId ?? payload?.ticket_id ?? null,
      state: true,
    }));

    // Bet je prošao — označi sesiju, ažuriraj storage i resetuj inactivity timer
    this.turboAtLeastOneBetPlaced = true;
    const _tid = ticketId ?? payload?.ticket_id;
    const _sess = this._loadTurboSession(_tid);
    this._saveTurboSession(_tid, true, _sess?.startedAt);
    this._startTurboInactivityTimer(_tid);

    if (ticketUid != null) {
      this.allowTurboDrop(ticketUid);

      // zapamti win za ovaj UID (dodaćemo ga tek u ballDone)
      const winNow = Number(payload?.win_money ?? 0) || 0;
      if (winNow > 0) {
        this.pendingTurboWins.set(ticketUid, winNow);
        this.dlog("STORE WIN", { uid: ticketUid, win: winNow });
      } else {
        this.dlog("STORE WIN (zero/none)", { uid: ticketUid, win: winNow });
      }

      // UI slot index mora biti 0..(levels) tj. 0..numberOfRows (slotCount = numberOfRows + 1)
      const rowsNow = Number(store.getState()?.numberOfRows ?? st?.numberOfRows ?? 8);
      const maxSlot = Number.isFinite(rowsNow) && rowsNow >= 1 ? rowsNow : 8;
      const slotCount = maxSlot + 1;

      let uiSlot = Number(payload?.id);

      // ako id nije validan za trenutni broj slotova, radi fallback
      if (!Number.isFinite(uiSlot) || uiSlot < 0 || uiSlot > maxSlot) {
        const fallbackBase = Number(payload?.itemId ?? payload?.item_id ?? payload?.sub_id ?? 0);
        uiSlot = Number.isFinite(fallbackBase)
          ? (Math.abs(fallbackBase) % slotCount)
          : Math.floor(Math.random() * slotCount);
      }

      if (Number(payload?.id) !== uiSlot) {
        this.dlog("TURBO uiSlot fallback", { payloadId: payload?.id, itemId: payload?.itemId, uiSlot });
      }

      // trigger drop sa TAČNO tim UID-om (isto će stići u ballDone)
      store.dispatch(setActiveBet({
        bet_passed: true,
        id: uiSlot,             // <<< BITNO: sada je uvek 0..8
        ticket_uid: ticketUid,
        isTurboItem: true,
      }));

      // dodatno: zabeleži stanje posle store-a
      this.debugListTurboWins();
    } else {
      this.dlog("MISSING FIELDS for turbo item", { payload });
    }

    // auto-nastavak: kratka odgoda da liveTurboUids i state budu sigurno ažurirani pre _tryTurboNext
    if (this.turboHold) {
      setTimeout(() => this._tryTurboNext(), 50);
    }
  }

  turboCashout(payload) {
    const ticketIdNum = Number(payload?.ticket_id);
    if (!Number.isFinite(ticketIdNum)) return;
    this.turboAutoCashoutPending = false;

    // Pročitamo flag PRE cleanup-a da ne ostane false kad ga koristimo dolje
    const wasInactivity = this.turboCashoutFromInactivity;

    // NEW: ako smo čekali "end after balls", očisti pending
    if (this.pendingEndTicketId != null && Number(this.pendingEndTicketId) === Number(ticketIdNum)) {
      this.pendingEndTicketId = null;
    }
    this.liveTurboCountByTicket.delete(ticketIdNum);

    this.clearTurboDropsForTicket(ticketIdNum);
    this._clearTurboRateTimer();
    this._clearTurboInactivityTimer();
    this.turboAtLeastOneBetPlaced = false;
    this.turboCashoutFromInactivity = false;
    this._clearTurboSession(ticketIdNum);

    // 0) označi ticket kao cashout-ovan i očisti pending
    this.cashedOutTickets.add(ticketIdNum);
    this._clearPendingWinsForTicket(ticketIdNum);

    // 1) zaustavi turbo hold/pending
    this.turboHold = false;
    this.turboPending = false;

    // 2) resetuj turbo mode
    store.dispatch(setTurboMode({
      value: 0,
      ticketId: null,
      state: false,
    }));

    // 3) zatvori turbo modal
    store.dispatch(setTurboModeModal({ state: false }));

    // 3.1) RESTART ako je tražen (START dok je turbo bio aktivan)
    const shouldRestart =
      this.turboRestart &&
      Number.isFinite(this.turboRestartForTicket) &&
      Number(this.turboRestartForTicket) === Number(ticketIdNum);

    if (shouldRestart) {
      const st = store.getState();
      const sid = st.login?.sid;

      const betAmount = this.turboRestart.betAmount;
      const rows = this.turboRestart.rows ?? st.numberOfRows;
      const level = this.turboRestart.level ?? gameDifficultyConverter(st.gameDifficulty);

      const winDisplay = formatWinForDisplay(payload?.win);
      const currency = store.getState().login?.player_data?.currency_code?.CurrencyID || "";

      if (!wasInactivity) {
        store.dispatch(setPopupMessage({
          message: `${translate("cashout_success") || "Cashout successful"} — ${translate("you_won") || "you won"} ${winDisplay} ${currency}!`,
          delay: 3500,
        }));
      }
      soundFxPlayer.play("cashout")

      // očisti request pre slanja (da ne duplira)
      this.turboRestart = null;
      this.turboRestartForTicket = null;

      if (sid && betAmount) {
        store.dispatch({
          type: "WEBSOCKET_SEND",
          payload: [
            "placed_bet",
            {
              sid,
              betAmount,
              isAutobet: false,
              rows,
              level,
              isTurbo: true,
            },
          ],
        });
      }

      setTimeout(() => this.getUserBalance(), 800);
      return;
    }

    // --- normalan cashout (bez restart-a) ---
    const winDisplay = formatWinForDisplay(payload?.win);
    const currency = store.getState().login?.player_data?.currency_code?.CurrencyID || "";

    // Ako je cashout pokrenula inactivity logika, poruka je već prikazana — ne prepišemo je
    if (!wasInactivity) {
      store.dispatch(setPopupMessage({
        message: `${translate("cashout_success") || "Cashout successful"} — ${translate("you_won") || "you won"} ${winDisplay} ${currency}!`,
        delay: 6000,
      }));
    }
    soundFxPlayer.play("cashout")

    setTimeout(() => this.getUserBalance(), 800);
  }

  // === BET ACK (glavna tačka za paralelne betove) ===
  betAck(payload) {
    // payload: { balance, bet, bet_passed, id, ticket_id, win }
    const ticketId = Number(payload.ticket_id);
    const winAmount = Number(payload.win);

    const betAmount = Number(payload.bet) || 0;
    const betMinor = toMinor(betAmount);

    const before = store.getState().balance.balance;
    tlog("ACK in", { ticketId, id: payload.id, bet_passed: payload.bet_passed, win: winAmount, ackBalance: payload.balance, beforeClientBalance: before });

    if (payload?.bet_passed === false) {
      store.dispatch(
        upsertFromAck({
          ticketId,
          winAmount: 0,
          meta: {
            wsId: payload.id,
            bet: Number(payload.bet),
            bet_passed: false,
            serverBalanceAtAck: Number(payload.balance),
          },
        })
      );
      // nema win-a, očisti pending
      store.dispatch(removePending({ ticketId }));

      const after = store.getState().balance.balance;
      tlog("ACK applied (bet_passed=false)", { afterClientBalance: after });
      return;
    }

    // bet_passed === true
    store.dispatch(
      upsertFromAck({
        ticketId,
        winAmount,
        meta: {
          wsId: payload.id,
          bet: Number(payload.bet),
          bet_passed: true,
          serverBalanceAtAck: Number(payload.balance),
        },
      })
    );

    // odmah prikaži server balance sa skinutim bet-om
    this._addMinor(-betMinor);

    // Event za spuštanje lopte (da GamePlay pozove dropBall)
    const rowsNow = Number(store.getState()?.numberOfRows ?? 8);
    const maxSlot = Number.isFinite(rowsNow) && rowsNow >= 1 ? rowsNow : 8;

    let uiSlot = Number(payload.id);
    if (!Number.isFinite(uiSlot)) uiSlot = 0;

    // ako server ikad pošalje out-of-range (ili promeni format), nemoj da puca animacija
    if (uiSlot < 0) uiSlot = 0;
    if (uiSlot > maxSlot) uiSlot = maxSlot;

    store.dispatch(
      setActiveBet({
        bet_passed: true,
        id: uiSlot,
        ticket_id: ticketId,
      })
    );

    // Ako je ball_done došao pre ACK-a, ovo će dodati win i očistiti pending
    this._settleIfReady(ticketId);
  }

  // === Bonus rounds expired ===
  bonusExpired(value) {
    if (!value) return;

    if (store.getState().freeBet) {
      store.dispatch(
        setFreeTicketInfo({
          ...store.getState().freeTicketInfo,
          freeTicketCount: 1,
        })
      );
    } else {
      store.dispatch(toggleFreeBetsState(false));
      setsProperBonusLabel(false);
      store.dispatch(
        setFreeTicketInfo({
          noOfRounds: 0,
          value: 0,
          currency: "",
          freeTicketCount: 0,
          validUntil: null,
        })
      );
      store.dispatch(setAlreadyShownBonusModal(false));
    }
  }

  // === Cashout ack (ako više ne koristiš, slobodno ukloni ceo metod i import) ===
  cashoutAck(data) {
    store.dispatch(setCashout(data));
    if (data?.win) {
      this.getUserBalance();
    }
  }

  // === Ostale util poruke ===
  playerException(data) {
    if (data) {
      // Prikaži poruku
      store.dispatch(setPopupMessage({ delay: 5000, message: data }));

      // Ako smo usred turbo item-a i stigla je greška, oslobodi pending i prekini burst
      if (this.turboPending) {
        this._clearTurboWatchdog();
        this._clearTurboRateTimer();
        this.turboPending = false;
        this.turboHold = false; // prekini trenutni “hold”; korisnik može ponovo da pritisne
      }
    }
  }

  sessionStatus(data) {
    if (data) {
      store.dispatch(setServerMessage(data));
    }
  }

  betHistory(data) {
    if (Array.isArray(data)) {
      store.dispatch(setBetHistoryList(data));
    }
  }

  // === Free tickets ===
  freeTickets(data) {
    const parts = data?.message?.MessageText?.split(";") || [];
    const bonusRounds = Number(parts[0] ?? 0);
    const amountAndCurrency = (parts[1] ?? "").split(" ");
    const amount = parseFloat(amountAndCurrency[0] ?? "0");
    const currency = amountAndCurrency[1] ?? "";
    const timestamp =
      parts.length === 3 && /\d/.test((parts[2] ?? "").trim())
        ? (parts[2] ?? "").trim()
        : null;

    if (shouldShowBonusModal(currency)) {
      store.dispatch(
        setBounsRoundsModal({
          show: true,
          noOfRounds: bonusRounds,
          validUntil: timestamp,
          value: amount,
          currency,
          alreadyShown: false,
        })
      );
    }
  }
}

const plinkoTransport = new PlinkoTransport();
export default plinkoTransport;
